module.exports = __webpack_public_path__ + "img/ct.2ecb67a2.png";